import {Link} from 'react-router'
import moment from 'moment'
import styles from './BillingReminderVersionTwo.css'

class BillingReminderVersionTwo extends React.Component {
  render () {
    let {user} = this.props

    return (user &&
      <div>
        {
          this.isExpired(user)
            ? <div>
              <div className={`alert alert-warning ${styles['billing-reminder']} ${styles['billing-reminder-expired']}`}>
                <div className={`col-md-12 text-center ${styles['billing-reminder-label']}`}>
                  <strong>
                    {this.billingReminder(user)}
                  </strong>
                </div>
              </div>
            </div>
          : <div>
            <div className={`alert alert-warning ${styles['billing-reminder']}`}>
              <div className={`col-md-6 text-left ${styles['billing-reminder-label']}`}>
                <strong>
                  {this.billingReminder(user)}
                </strong>
              </div>
              <div className={`col-md-6 text-right ${styles['billing-reminder-link']}`}>
                <Link to={user.is_owner && '/settings/billing'} className={`${user.is_owner ? styles['text-notif'] : styles['disable-link']} btn btn-default btn-xs`}>
                  <strong>
                    Subscribe Now
                  </strong>
                </Link>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

  isExpired = (user) => {
    const {subscriptionExpired} = this.props
    let expired = this.calculateDaysLeft(user) <= 0
    if (expired) {
      subscriptionExpired.expired = true
    }
    return expired
  }

  isTrial = (user) => {
    return user.business.is_trial
  }

  isAlreadySubscribed = (user) => {
    return user.already_subscribed
  }

  calculateDaysLeft = (user) => {
    let calculatedDaysLeft = Math.ceil((moment(user.business.expired_at).diff(moment(), 'hours')) / 24)
    let currentDaysInMonth = moment().daysInMonth()
    let daysLeft = 0
    if (calculatedDaysLeft > currentDaysInMonth) {
      daysLeft = currentDaysInMonth
    } else {
      daysLeft = calculatedDaysLeft
    }
    return daysLeft
  }

  billingReminder = (user) => {
    let daysLeft = this.calculateDaysLeft(user)
    let reminder = null
    if (this.isExpired(user)) {
      reminder = 'Your subscription has expired'
    } else {
      if (this.isTrial(user) && !this.isAlreadySubscribed(user)) {
        reminder = `Your trial will end in ${daysLeft} day(s)`
      } else if (!this.isTrial(user) && daysLeft <= 14) {
        reminder = `Your subscription will expire in ${daysLeft} day(s)`
      }
    }
    return reminder
  }
}

BillingReminderVersionTwo.propTypes = {
  user: React.PropTypes.object,
  subscriptionExpired: React.PropTypes.object
}

export default BillingReminderVersionTwo



// WEBPACK FOOTER //
// ./app/components/BillingReminderVersionTwo/BillingReminderVersionTwo.js